'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lib = require('../lib-75591456.js');
var definitions = require('../definitions-4ae1604d.js');
var index = require('../index-63663506.js');
require('tslib');
require('@prisjakt/design-tokens/light-theme-colors');
require('react');
require('styled-components');
require('@prisjakt/design-tokens/measurements');
require('../utils-eb39d0ac.js');
require('../env-100217af.js');

var RowCard = lib.variant('RowCard', index.Card, {
    direction: definitions.Axis.X,
});
var ColumnCard = lib.variant('ColumnCard', index.Card, {
    direction: definitions.Axis.Y,
});

exports.ColumnCard = ColumnCard;
exports.RowCard = RowCard;
//# sourceMappingURL=variants.js.map
